import {
  ADD_USER_NAME,
  AUTHENTICAT_USER,
  SET_USER_DATA,
  ON_REMEMBER_ME,
  SET_AI_RESPONSE,
} from "../actions/authAction";

const initialState = {
  isLoggin: false,
  aiResponse: {},
  userNameData: {},
  user: null,
  rememberMe: false,
  credentials: {
    email: "",
    password: "",
  },
  privileges: {
    isAdmin: false,
    hasSubscription: false,
    organizationName: "",
    onPremises: false,
    planType: "",
    isSubscriptionExpired: false,
    isSubscriptionCnacelled: false,
  },
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICAT_USER:
      return {
        ...state,
        isLoggin: action.payload,
      };
    case SET_AI_RESPONSE:
      return {
        ...state,
        aiResponse: action.payload,
      };
    case ADD_USER_NAME:
      return {
        ...state,
        userNameData: action.payload,
      };
      break;
    case SET_USER_DATA:
      {
        const userData = action.payload;

        const organization =
          typeof userData.organization === "object" &&
          userData.organization !== null
            ? userData.organization
            : {};

        const activeSubscription =
          typeof organization.active_subscription === "object" &&
          organization.active_subscription !== null
            ? organization.active_subscription
            : {};
        const endAt = activeSubscription?.end_at;
        const cancelledAt = activeSubscription?.cancelled_at;

        const isExpired = endAt ? new Date(endAt) < new Date() : true;
        const isCancelled = !!cancelledAt;

        return {
          ...state,
          user: userData,
          privileges: {
            isAdmin:
              !!organization.admin_id && organization.admin_id === userData.id,
            hasSubscription: !!organization.active_subscription,
            organizationName: organization.name || "",
            onPremises: !!organization.on_premises,
            planType: activeSubscription?.type,
            isSubscriptionExpired: isExpired,
            isSubscriptionCnacelled: isCancelled,
          },
        };
      }
      break;
    case ON_REMEMBER_ME:
      return {
        ...state,
        rememberMe: !state.rememberMe,
        credentials: {
          ...state.credentials,
          email: action.payload.email,
          password: action.payload.password,
        },
      };
      break;
    default:
      return state;
  }
}
